import React from "react";
import { Link as ScrollLink } from "react-scroll";

import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import YouTubeIcon from "@mui/icons-material/YouTube";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import ArrowUpwardRoundedIcon from "@mui/icons-material/ArrowUpwardRounded";
import logo from '../assets/logo.png'
import "./Footer.css";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="foot">
      <div className="foot__container">
        <div className="foot__top">
          <div className="foot__brand">
            <div className="foot__logo">

              <img src={logo} />
            </div>
            <div>
              <div className="foot__name">HB Height High-Rise</div>
              <div className="foot__tagline">
                Premium residences • Modern lifestyle • Secure investment
              </div>
            </div>
          </div>

          <div className="foot__cols">
            <div className="foot__col">
              <div className="foot__colTitle">Explore</div>
              <ScrollLink to="about" smooth duration={600} offset={-10} className="foot__link">
                About
              </ScrollLink>
              <ScrollLink to="residences" smooth duration={600} offset={-10} className="foot__link">
                Residences
              </ScrollLink>
              <ScrollLink to="amenities" smooth duration={600} offset={-10} className="foot__link">
                Amenities
              </ScrollLink>
              <ScrollLink to="gallery" smooth duration={600} offset={-10} className="foot__link">
                Gallery
              </ScrollLink>
            </div>

            <div className="foot__col">
              <div className="foot__colTitle">Information</div>
              <ScrollLink to="location" smooth duration={600} offset={-10} className="foot__link">
                Location
              </ScrollLink>
              <ScrollLink to="payment" smooth duration={600} offset={-10} className="foot__link">
                Payment Plan
              </ScrollLink>
              <ScrollLink to="faq" smooth duration={600} offset={-10} className="foot__link">
                FAQs
              </ScrollLink>
              <ScrollLink to="contact" smooth duration={600} offset={-10} className="foot__link">
                Contact
              </ScrollLink>
            </div>

            <div className="foot__col">
              <div className="foot__colTitle">Social</div>

              <div className="foot__socials">
                <a className="foot__social" href="https://www.instagram.com/hafizbrothersestate?igsh=Mmhzbm95a3plcDhm&utm_source=qr" aria-label="Instagram">
                  <InstagramIcon />
                </a>
                <a className="foot__social" href="https://www.facebook.com/hhafizbrothers" aria-label="Facebook">
                  <FacebookIcon />
                </a>
                <a className="foot__social" href="https://www.youtube.com/@hafizbrothersestate" aria-label="YouTube">
                  <YouTubeIcon />
                </a>
                {/* <a className="foot__social" href="#" aria-label="LinkedIn">
                  <LinkedInIcon />
                </a> */}
              </div>

              <div className="foot__mini">
                Replace social links later. We’ll connect real URLs when branding is final.
              </div>
            </div>
          </div>
        </div>

        <div className="foot__bottom">
          <div className="foot__copy">© {year} HB High-Rise. All rights reserved.</div>

          <ScrollLink to="home" smooth duration={650} className="foot__topBtn">
            <ArrowUpwardRoundedIcon />
            Back to top
          </ScrollLink>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
